export default __webpack_public_path__ + "static/media/logo-no-text.145703be.svg";